import React from "react";
import Helmet from "react-helmet";
import { useIntl, FormattedMessage } from "react-intl";

import { OutboundLink } from 'gatsby-plugin-google-gtag'

import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import PinterestIcon from '@mui/icons-material/Pinterest';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneEnabledOutlinedIcon from '@mui/icons-material/PhoneEnabledOutlined';
import Layout from "../components/Layout";

import { Global } from "@emotion/react";
import { emotionGlobalCss } from "../styles/contactUs";
import ContactForm from "../components/ContactForm";

export default function ContactUs() {
  const intl = useIntl();
  const t = intl.formatMessage;

  return (
    <>
      <Global styles={emotionGlobalCss} />
      <Layout>
        <Helmet>
          <title>{t({ id: "contact-us.title" })}</title>
        </Helmet>
        <div>

          <div className="heroImage" style={{ backgroundImage: "url(https://aee-image.s3.ca-central-1.amazonaws.com/MapMarkerImage.png)" }}>
         
          
            <div className="wrap">
              <div className="innerHeroImage">
                <h1><FormattedMessage id="contact-us.maintext1" /></h1>
              </div>
            </div>
          </div>

          <div className="site-inner">
            <div className="content-sidebar-wrap">
              <div className="wrap">

                <main className="content" id="genesis-content">
                  <div className="flexContact">
                    <div className="leftContac">
                      <h2 className="borderGreen"><FormattedMessage id="card1.title" /></h2>
                      <p>&nbsp;</p>

                      <div className="eachF">
                        <MailOutlineIcon sx={{ color: "#70c000", fontSize: 40, marginTop: "15px" }} />
                        <div className="rightF"><FormattedMessage id="card1.attributetext3" />
                          <br /><a style={{ textDecoration: 'none' }} href={"mailto:" + t({ id: "contact-info.email" })}><FormattedMessage id="contact-info.email" /></a></div>
                      </div>
                      <div className="eachF">
                        <PhoneEnabledOutlinedIcon sx={{ color: "#70c000", fontSize: 40, marginTop: "15px" }} />
                        <div className="rightF"><FormattedMessage id="card1.attributetext5" />
                          <br /><a style={{ textDecoration: 'none' }} href={"tel:" + t({ id: "contact-info.telephone-number" })}><FormattedMessage id="contact-info.telephone-number" /></a></div>
                      </div>
                      <p>&nbsp;</p>
                      <p>&nbsp;</p>

                      <div className="socialMedia">
                        <OutboundLink href="https://www.facebook.com/andmarecoenergy" ><i><FacebookRoundedIcon sx={{ width: "80%", height: "100%" }} /></i></OutboundLink>
                        <OutboundLink href="https://www.instagram.com/andmarecoenergy/" ><i><InstagramIcon sx={{ width: "80%", height: "100%" }} /></i></OutboundLink>
                        <OutboundLink href="https://twitter.com/Andmarecoenergy" ><i><TwitterIcon sx={{ width: "80%", height: "100%" }} /></i></OutboundLink>
                        {/* <OutboundLink href="https://www.pinterest.ca/adominique0872/" ><i><PinterestIcon sx={{ width: "80%", height: "100%" }} /></i></OutboundLink> */}
                        <OutboundLink href="https://www.linkedin.com/company/andmar-eco-energy" ><i><LinkedInIcon sx={{ width: "80%", height: "100%" }} /></i></OutboundLink>
                        <OutboundLink href="https://www.youtube.com/channel/UCa1Rx6rH6P-ZIBy9bXkt9AQ" ><i><YouTubeIcon sx={{ width: "80%", height: "100%" }} /></i></OutboundLink>
                      </div>
                    </div>

                    <div className="rightContac">
                      <h2 className="borderGreen"><FormattedMessage id="card2.title" /></h2>
                     
                      <ContactForm/>
                    </div>


                    <div className="bottomContac">

                      <h2 style={{fontSize:"2rem"}}>
                        <CalendarMonthOutlinedIcon sx={{ color: "#70c000", fontSize: 40, marginBottom: "-6px" }} />
                        <FormattedMessage id="hours.title" />
                      </h2>
                      <div className="weeklyHours">

                        <div className="boxHours">
                          <div className="day"><FormattedMessage id="hours.attributetag1" /></div>
                          <div className="hour"><FormattedMessage id="hours.attributetext1" /></div>
                        </div>

                        <div className="boxHours">
                          <div className="day"><FormattedMessage id="hours.attributetag2" /></div>
                          <div className="hour"><FormattedMessage id="hours.attributetext2" /></div>
                        </div>

                        <div className="boxHours">
                          <div className="day"><FormattedMessage id="hours.attributetag3" /></div>
                          <div className="hour"><FormattedMessage id="hours.attributetext3" /></div>
                        </div>

                        <div className="boxHours">
                          <div className="day"><FormattedMessage id="hours.attributetag4" /></div>
                          <div className="hour"><FormattedMessage id="hours.attributetext4" /></div>
                        </div>

                        <div className="boxHours">
                          <div className="day"><FormattedMessage id="hours.attributetag5" /></div>
                          <div className="hour"><FormattedMessage id="hours.attributetext5" /></div>
                        </div>

                        <div className="boxHours">
                          <div className="day"><FormattedMessage id="hours.attributetag6" /></div>
                          <div className="hour"><FormattedMessage id="hours.attributetext6" /></div>
                        </div>

                        <div className="boxHours">
                          <div className="day"><FormattedMessage id="hours.attributetag7" /></div>
                          <div className="hour"><FormattedMessage id="hours.attributetext7" /></div>
                        </div>

                      </div>

                    </div>


                  </div>
                </main>



              </div>
            </div>
          </div>




          {/* <ModalPopPup style={t({ id: "modal-class" })}/> */}

        </div>
      </Layout>
    </>
  )
};

